/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class TumblrOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Tumblr Blog"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Tumblr Blogs to dlvr.it</p>
                    )}
                    typeLabel="Tumblr Blog"/>
            </div>
        );
    }
}

TumblrOutput.displayName = "TumblrOutput";

export default TumblrOutput;
